
import { CatalogData } from './data';
import { ExtendedData } from './extended-data';


export class MetaData {
    title: string;
    parrot_id: string;
    display_name: string;
    created_on: string;
    tmsseriesID: string;
    data: CatalogData;
    extended: ExtendedData;
}




// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-api/model/metadata.ts